import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

/**
 * Web entry point. A thin top-level boundary surfaces any bootstrap/render
 * crash as readable text instead of a blank page — the in-app
 * GlobalErrorBoundary handles everything below the root.
 */
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return React.createElement(
        'div',
        {
          style: {
            padding: 32,
            fontFamily: 'monospace',
            color: '#3D3D3D',
            fontSize: 14,
            whiteSpace: 'pre-wrap',
          },
        },
        '🔴 RENDER ERROR:\n\n' + this.state.error.message + '\n\n' + this.state.error.stack,
      );
    }
    return this.props.children;
  }
}

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(React.createElement(ErrorBoundary, null, React.createElement(App)));
} else {
  document.body.innerHTML =
    '<div style="padding:32px;color:#3D3D3D;font-size:16px">No #root element found</div>';
}
